import React, { Fragment } from "react";

const  horaires = (props) => {
    let content = props.horaires.map((horaire,index=[1])=>{
        return <li key={1}> Du {horaire.du} au {horaire.au} - De {horaire.heures[0].de} à {horaire.heures[0].a} </li>
    });
    return(
        <Fragment>
            <ul>
                {content}
            </ul>    
        </Fragment>
    );    
};
export default horaires;